<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="devices"
      item-key="code"
      class="elevation-1"
      :search="search"
      :loading="loading"
      show-expand
      single-expand
      :expanded.sync="expanded"
    >
      <template v-slot:top>
        <v-toolbar flat dark color="#598639">
          <v-toolbar-title>{{ $t("Statistics") }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('Search')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-btn
            class="ml-4"
            color="black"
            dark
            :disabled="!devices.length"
            @click="downloadCsv"
          >
            <v-icon left>mdi-download</v-icon>
            {{ $t("CSV") }}
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.kernel="{item}">
        {{RegExp(/^\d+\.\d+\.\d+/).exec(item.kernel)?.[0] || ""}}
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-4">
          <v-row dense>
            <v-col cols="12" md="6">
              <div class="text-subtitle-2 mb-1">{{ $t("System") }}</div>
              <div><strong>{{ $t("Kernel") }}:</strong> {{ item.kernel }}</div>
              <div><strong>{{ $t("Model") }}:</strong> {{ item.model }}</div>
              <div><strong>{{ $t("OS") }}:</strong> {{ item.os_pretty_name }}</div>
              <div><strong>{{ $t("OS Version") }}:</strong> {{ item.os_version }}</div>
              <div><strong>{{ $t("Report time") }}:</strong> {{ item.report_timestamp }}</div>
              <div><strong>SSH port:</strong> {{ item.ssh_port }}</div>
              <div><strong>FOM IDs:</strong> {{ item.fom_ids }}</div>
            </v-col>

            <v-col cols="12" md="6">
              <div class="text-subtitle-2 mb-1">{{ $t("Network") }}</div>
              <div v-if="item.eth0_ip"><strong>eth0:</strong> {{ item.eth0_ip }}</div>
              <div v-if="item.eth1_ip"><strong>eth1:</strong> {{ item.eth1_ip }}</div>
              <div v-if="item.wlan0_ip"><strong>wlan0:</strong> {{ item.wlan0_ip }}</div>
              <div v-if="item.tun0_ip"><strong>tun0:</strong> {{ item.tun0_ip }}</div>
              <div v-if="item.wwan0_ip"><strong>wwan0:</strong> {{ item.wwan0_ip }}</div>
              

              <div class="text-subtitle-2 mt-3 mb-1">{{ $t("Disk free") }}</div>
              <div v-if="item.df_root"><strong>/:</strong> {{ item.df_root }}</div>
              <div v-if="item.df_boot"><strong>/boot:</strong> {{ item.df_boot }}</div>
              <div v-if="item.df_mnt_data"><strong>/mnt/data:</strong> {{ item.df_mnt_data }}</div>
              <div v-if="item.df_tmp"><strong>/tmp:</strong> {{ item.df_tmp }}</div>
              <div v-if="item.df_run"><strong>/run:</strong> {{ item.df_run }}</div>
              <div v-if="item.df_dev"><strong>/dev:</strong> {{ item.df_dev }}</div>
              <div v-if="item.df_dev_shm"><strong>/dev/shm:</strong> {{ item.df_dev_shm }}</div>
              <div v-if="item.df_sys_fs_cgroup"><strong>/sys/fs/cgroup:</strong> {{ item.df_sys_fs_cgroup }}</div>
              <div v-if="item.df_var_volatile"><strong>/var/volatile:</strong> {{ item.df_var_volatile }}</div>

              <div class="text-subtitle-2 mt-3 mb-1">{{ $t("Package versions") }}</div>
              <div><strong>fuelomatic2:</strong> {{ item.fuelomatic_version }}</div>
              <div><strong>wnr:</strong> {{ item.wnr_version }}</div>
              <div><strong>webapi2:</strong> {{ item.webapi2_version }}</div>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      loading: false,
      expanded: [],
      headers: [
        { text: this.$t ? this.$t("Code") : "Code", value: "code" },
        { text: "App name", value: "app_name" },
        { text: "FOM name", value: "fom_name" },
        { text: "VPN IP", value: "vpn_ip" },
        { text: "WAN IP", value: "wan_ip" },
        { text: "Module", value: "model" },
        { text: "Kernel", value: "kernel"   },
        { text: "App ver", value: "fuelomatic_version"   },
        { text: "Comm.", value: "stn_comm" },
        { text: "Last seen", value: "last_seen" },
        { text: "", value: "data-table-expand" },
      ],
      csvColumns: [
        "code", "stn_name", "stn_code","stn_comm", "hostname", "fom_name", "app_name",
        "vpn_ip", "wan_ip", "ssh_port", "last_seen", "report_timestamp",
        "kernel", "model", "os_id", "os_name", "os_version", "os_version_id",
        "os_pretty_name", "fom_ids",
        "eth0_ip", "eth1_ip","wwan0_ip", "wlan0_ip", "tun0_ip",
        "df_root", "df_boot", "df_mnt_data", "df_tmp", "df_run",
        "df_dev", "df_dev_shm", "df_sys_fs_cgroup", "df_var_volatile",
        "fuelomatic_version", "wnr_version", "webapi2_version",
      ],
      devices: [],
    };
  },
  methods: {
    async initialize() {
      try {
        this.loading = true;
        const res = await this.$http.get(this.$serverAPI + "/statistic/devices");
        this.devices = res.data;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    csvEscape(val) {
      if (val === null || val === undefined) return "";
      const s = String(val);
      return /[",\n\r;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    },
    buildCsv(rows, cols) {
      const lines = [cols.join(",")];
      for (const r of rows) {
        lines.push(cols.map((c) => this.csvEscape(r[c])).join(","));
      }
      return lines.join("\r\n");
    },
    downloadCsv() {
      const csv = this.buildCsv(this.devices, this.csvColumns);
      const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      const ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
      a.href = url;
      a.download = `statistics_${ts}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
  },
  created() {
    this.initialize();
  },
};
</script>

<style>
</style>

